import en from "@/locales/en.json";
import es from "@/locales/es.json";
import fr from "@/locales/fr.json";
import de from "@/locales/de.json";

const DICTS = { en, es, fr, de };
const LOCALES = { it: "it-IT", en: "en-GB", es: "es-ES", fr: "fr-FR", de: "de-DE" };
export const LANGUAGES = [["it", "Italiano"], ["en", "English"], ["es", "Español"], ["fr", "Français"], ["de", "Deutsch"]];
const ATTRS = ["placeholder", "title", "aria-label"];
const ORIG = new WeakMap();

let current = localStorage.getItem("nx_lang") || "it";
let observer = null;

export const getLang = () => current;
export const dateLocale = () => LOCALES[current] || "it-IT";

export function tr(text) {
  if (current === "it" || !text) return text;
  const dict = DICTS[current];
  const key = text.trim();
  if (dict[key]) return text.replace(key, dict[key]);
  const core = key.replace(/^[^\p{L}]+|[^\p{L}.!?…]+$/gu, "");
  if (core && dict[core]) return text.replace(core, dict[core]);
  const m = key.match(/^([^,]+), ([^,]{1,30})$/);
  if (m && dict[m[1]]) return text.replace(m[1], dict[m[1]]);
  return text;
}

function translateText(node) {
  const src = node.nodeValue;
  const known = ORIG.get(node);
  const original = known && (src === known.out) ? known.src : src;
  const out = tr(original);
  if (out !== src) {
    ORIG.set(node, { src: original, out });
    node.nodeValue = out;
  } else if (!known || src !== known.out) {
    ORIG.set(node, { src, out: src });
  }
}

function translateEl(el) {
  for (const a of ATTRS) {
    const v = el.getAttribute?.(a);
    if (!v) continue;
    const key = `data-i18n-${a}`;
    const orig = el.getAttribute(key) && tr(el.getAttribute(key)) === v ? el.getAttribute(key) : v;
    const out = tr(orig);
    if (out !== v) {
      el.setAttribute(key, orig);
      el.setAttribute(a, out);
    }
  }
}

function walk(root) {
  if (root.nodeType === 3) return translateText(root);
  if (root.nodeType !== 1 || root.tagName === "SCRIPT" || root.tagName === "STYLE") return;
  translateEl(root);
  const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
  let n = w.nextNode();
  while (n) {
    if (n.nodeType === 3) translateText(n);
    else translateEl(n);
    n = w.nextNode();
  }
}

function start() {
  observer?.disconnect();
  if (current === "it") return;
  walk(document.body);
  observer = new MutationObserver((muts) => {
    observer.disconnect();
    for (const m of muts) {
      if (m.type === "characterData") translateText(m.target);
      else if (m.type === "attributes") translateEl(m.target);
      else m.addedNodes.forEach(walk);
    }
    observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  });
  observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ATTRS });
}

export function setLang(lang) {
  if (lang === current) return;
  const reload = current !== "it";
  current = lang;
  localStorage.setItem("nx_lang", lang);
  document.documentElement.lang = lang;
  if (reload) window.location.reload();
  else start();
}

export function initI18n() {
  document.documentElement.lang = current;
  start();
}
